import { render, staticRenderFns } from "./Son_CheckBox.vue?vue&type=template&id=b5a28b2e&scoped=true&"
import script from "./Son_CheckBox.vue?vue&type=script&lang=js&"
export * from "./Son_CheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a28b2e",
  null
  
)

export default component.exports